module.exports = __webpack_public_path__ + "media/images/facebook-logo-803aa4ef880b3b94dfd086aeab06172d.svg";